export enum TimeZone{
  Singapore_Standard_Time = "Singapore Standard Time",
  North_Asia_Standard_Time = "North Asia Standard Time",
  Taipei_Standard_Time = "Taipei Standard Time",
  Tokyo_Standard_Time = "Tokyo Standard Time",
  Korea_Standard_Time = "Korea Standard Time",
  AUS_Central_Standard_Time = "AUS Central Standard Time"
}
